import { useEffect, useRef, useState } from "react";

export function PreviewFrame({ children }) {
  const ref = useRef(null);
  const [scale, setScale] = useState(1);
  useEffect(() => {
    const ro = new ResizeObserver(([e]) => setScale(Math.min(1, (e.contentRect.width - 2) / 794)));
    ro.observe(ref.current);
    return () => ro.disconnect();
  }, []);
  return (
    <div ref={ref} className="w-full">
      <div className="shadow-lg border border-border/60 inline-block" style={{ lineHeight: 0 }}>
        {children(scale)}
      </div>
    </div>
  );
}
